// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeTwoToneSvg from "@fishx/icons-svg/es/asn/EyeTwoTone";
import FishxIcon from '../components/FishxIcon';

var EyeTwoTone = function EyeTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeTwoToneSvg
  }));
};

EyeTwoTone.displayName = 'EyeTwoTone';
export default React.forwardRef(EyeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EyeTwoTone.js
// module id = 2662
// module chunks = 0